class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector('.section-header'); 
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }
  

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    const searchInput = this.querySelector('input[type="search"]');
    const predictiveSearch = this.querySelector('predictive-search');
    const hasSearchValue = searchInput && searchInput.value.trim().length > 0;
    const searchHasFocus = searchInput && searchInput === document.activeElement;
    const dropdownOpen = predictiveSearch && predictiveSearch.hasAttribute('open');
    const userIsSearching = dropdownOpen || hasSearchValue || searchHasFocus;

    // Only close when user explicitly clicks outside or on overlay. Never close while typing or when results are open.
    if (!this.contains(event.target)) {
      if (userIsSearching) return; // ignore spurious outside clicks (e.g. keyboard/viewport) while searching
      this.close(false);
      return;
    }
    if (event.target.classList.contains('modal-overlay')) {
      if (userIsSearching) return;
      this.close(false);
    }
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
    
    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
    
    if(this.header.contains(this)) {
      this.header.classList.add('modal-open'); 
    }
   
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    if(this.header.contains(this)) this.header.classList.remove('modal-open');  
  }
}

customElements.define('details-modal', DetailsModal);
